import React from 'react'
import { FormProvider, useFormContext } from 'react-hook-form'
import { BasicData } from './AdminWarrantBasicData'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { SourcesFields } from '../shared/source-fields'
import { WarrantEntity } from 'types/WarrantEntity'
import { WarrantOrigins } from './AdminWarrantOrigins'

export function WarrantDataForm({
    warrant,
    setIsCustomFormDirty,
}: {
    warrant: WarrantEntity
    setIsCustomFormDirty: React.Dispatch<React.SetStateAction<boolean>>
}) {
    const formMethods = useFormContext()
    return (
        <FormProvider {...formMethods}>
            {warrant && <BasicData setIsCustomFormDirty={setIsCustomFormDirty} warrant={warrant} />}
            <Divider sx={{ my: 4 }} />
            {warrant && <WarrantOrigins warrant={warrant} setIsCustomFormDirty={setIsCustomFormDirty} />}
            <Divider sx={{ my: 4 }} />
            <Typography
                variant='h5'
                gutterBottom
                sx={{
                    display: 'block',
                }}
            >
                Källor
            </Typography>
            <SourcesFields allowUpload={false} warrant={warrant} setIsCustomFormDirty={setIsCustomFormDirty} />
        </FormProvider>
    )
}
